/**
 * Affiliate ID mapping for VM
 */
const BOOKINGCOM_AFFILIATE_ID_BY_PLATFORM: Record<string, number> = {
	WEB_DESKTOP: 305168,
	WEB_MOBILE: 364031,
	WEB_TABLET: 801134,
	ANDROID: 387161,
	ANDROID_TABLET: 386544,
	IOS: 387160,
	IPAD: 386543,
};

export type BookingcomPlatform = keyof typeof BOOKINGCOM_AFFILIATE_ID_BY_PLATFORM;

interface GetBookingcomUrlBaseParams {
	platform: BookingcomPlatform;
}

export function getBookingcomHomeUrl({ platform }: GetBookingcomUrlBaseParams): string {
	const url = new URL('https://www.booking.com/index.html');

	const searchParams = {
		aid: BOOKINGCOM_AFFILIATE_ID_BY_PLATFORM[platform],
	};

	for (const [searchName, value] of Object.entries(searchParams)) {
		url.searchParams.set(searchName, String(value));
	}

	return url.toString();
}

export function getBookingcomSearchResultsUrl({ platform, arrival, arrivalCoordinates }: GetBookingcomUrlBaseParams & (
	| { arrival: string; arrivalCoordinates?: { lat: number; lng: number } }
	| { arrival?: string; arrivalCoordinates: { lat: number; lng: number } }
)) {
	const url = new URL('https://www.booking.com/searchresults.html');

	const searchParams = {
		// aid: affiliate id selon la plateforme
		aid: BOOKINGCOM_AFFILIATE_ID_BY_PLATFORM[platform],
		// ss — Search String: the text query for destination (city, hotel name, region, etc.)
		// Example: ss=London%2C+United+Kingdom
		...(arrival ? { ss: arrival } : {}),
		...(arrivalCoordinates
			? {
					place_id_lat: arrivalCoordinates.lat,
					place_id_lon: arrivalCoordinates.lng,
				}
			: {}),
		// nflt: Name Filter, utilisé pour appliquer des filtres dans la recherche (étoiles, équipements, etc.)
		// ht_id=204 = id du type d’hébergement "Hôtels"
		nflt: 'ht_id=204',
		...getDefaultCheckinCheckoutFromPlatform(platform),
	};

	for (const [searchName, value] of Object.entries(searchParams)) {
		url.searchParams.set(searchName, String(value));
	}

	return url.toString();
}

function getDateToYearMonthDayKebabCaseString(date: Date) {
	return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
}

export function getDefaultCheckinCheckoutFromPlatform(platform: BookingcomPlatform): { checkin: string; checkout: string } {
	const date = new Date();
	const startDate = platform === 'WEB_DESKTOP' ? getNextDayDate(date) : date;
	const endDate = getNextDayDate(startDate);

	return {
		checkin: getDateToYearMonthDayKebabCaseString(startDate),
		checkout: getDateToYearMonthDayKebabCaseString(endDate),
	};
}

function getNextDayDate(date: Date) {
	return new Date(date.getTime() + 24 * 60 * 60 * 1000);
}
